import VisionImg from "../../Images/Vision.jpeg";
export function Vision() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div className="about-box-layout1 order-xl-8 col-xl-8 col-12">
            <div className="item-content">
              <h2 className="item-title">Our mission:</h2>
              <p>
                Whether large pharma or small biotech; small or large molecule;
                a single service need or an end-to-end solution, we give
                complete attention to each customer, offering a reliable and
                seamless experience.Leveraging our innovation mindset, rich
                scientific talent and empowered teams, we consistently deliver
                value to our customers.
              </p>
            </div>
            <div className="item-content">
              <h2 className="item-title">Our Values:</h2>
              <h4>Quality</h4>
              <div>
                Quality is a benchmark of perfection for the end-user, and we
                are constantly striving to maintain & improve our quality
                standards. We conduct our every operation with adherence to the
                highest parameters of cGMP right from product development till
                it reaches the end user.
              </div>
              <h4 className="mt-4">Safety</h4>
              <div>
                We pledge to be a responsible corporate citizen and realize the
                importance of integrating EHS matters effectively as part of our
                business activities. We take all practicable measures to create
                a safe and healthy workplace for our employees and a clean
                environment for our employees as well as the surrounding
                community.
              </div>
              <h4 className="mt-4">Innovation</h4>
              <div>
                We constantly upgrade our manufacturing facilities and adapt the
                technological innovations in our facilities to consistently
                excel and produce high-quality medicines at an affordable price
                for our customers.
              </div>
              <h4 className="mt-4">Trust</h4>
              <div>
                We hold ourselves to high standards of ethical behavior, conduct
                ourselves with uncompromising integrity and practice
                transparency. We observe zero tolerance for noncompliance, which
                is our effort toward maintaining and honoring the trust our
                customers and stakeholders place in us.
              </div>
              <h4 className="mt-4">Care</h4>
              <div>
                We consistently strive to positively impact and protect the
                lives of our patients, customers, stakeholders, the community,
                and the environment at large. We care for our employees and our
                customers and strive to create a healthy work environment for
                the people who dedicate their time working for us and for our
                end users for whom we aim at making healthcare affordable and
                accessible.
              </div>
              <h4 className="mt-4">Teamwork</h4>
              <div>
                We synchronize the efforts and energies, intellect of our people
                across all levels to deliver superlative results in all that we
                do. We encourage diverse opinions and yet collaborate in a
                coordinated and mutually supportive way.
              </div>
            </div>
          </div>
          <div
            className="about-box-layout2 order-xl-1 col-xl-4 col-lg-4 col-12 __web-inspector-hide-shortcut__"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={VisionImg} alt="about" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
